
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3764253e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./vue-my-dropdown.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./vue-my-dropdown.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3764253e\"}!../../vue-loader/lib/selector?type=template&index=0!./vue-my-dropdown.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/node_modules/vue-my-dropdown/src/vue-my-dropdown.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-my-dropdown.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3764253e", Component.options)
  } else {
    hotAPI.reload("data-v-3764253e", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-my-dropdown/src/vue-my-dropdown.vue
// module id = 134
// module chunks = 1